"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchLoader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LoadingScreen = require("../LoadingScreen.styles");

var _Search = require("./Search.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const SearchLoader = ({
  theme,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_Search.StyledSearchLoader, props, /*#__PURE__*/_react.default.createElement(_Search.StyledRow, null, /*#__PURE__*/_react.default.createElement(_LoadingScreen.StyledListItem, {
    width: "87%",
    height: "40px",
    theme: theme
  }), /*#__PURE__*/_react.default.createElement(_LoadingScreen.StyledListItem, {
    width: "36px",
    height: "36px",
    theme: theme
  }), /*#__PURE__*/_react.default.createElement(_LoadingScreen.StyledListItem, {
    width: "36px",
    height: "36px",
    theme: theme
  })));
};

exports.SearchLoader = SearchLoader;
SearchLoader.propTypes = {
  /**
   * white background :'light' ,
   * dark background:'dark'
   */
  theme: _propTypes.default.oneOf(['light', 'dark'])
};